import React from 'react';

// Renders either an imported SVG (a URL string ending in .svg or a data/static path)
// as an <img>, or an emoji/plain string as text. Lets us mix both freely.
export default function Icon({ icon, alt = '', className = '', size }) {
  if (!icon) return null;

  const isImage =
    typeof icon === 'string' &&
    (icon.includes('/static/') ||
      icon.startsWith('data:image') ||
      icon.startsWith('http') ||
      /\.(svg|png|jpe?g|webp|gif)$/i.test(icon));

  if (isImage) {
    const style = size ? { width: size, height: size, objectFit: 'contain' } : undefined;
    return <img src={icon} alt={alt} className={className} style={style} />;
  }

  // Emoji or any non-image string: render as-is.
  return <span className={className}>{icon}</span>;
}